<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" scrollable
                   :title="$t(`Unsold Lot Confirmation`)" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading">
      <div class="row">
        <div class="col-md-12">
          <bidder-select-input-widget value-field="paddle_number" :model="model" attribute="paddle_number"
                                      :auction-uuid="saleInfo.uuid"
                                      :rules="model.highest_bid_amount && model.highest_bid_amount > 0 ? 'required' : ''"/>
        </div>
        <div class="col-md-12">
          <input-widget :rules="model.paddle_number ? 'required|min_value:1' : 'min_value:1'" :model="model" attribute="highest_bid_amount"
                        type="number"/>
        </div>
        <div class="col-md-12">
          <b-alert show variant="info" class="text-justify">
            {{
              $t('Following inputs are as a shortcut to create highest bid manually before marking item as unsold. This should be filled only if you would like to create and track the highest bid manually. In any other case, please, ignore following fields and continue.')
            }}
          </b-alert>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import BidderSelectInputWidget from "@/core/widgets/BidderSelectInputWidget";
  import UnsoldLotModel from "@/modules/live-bids/UnsoldLotModel.model";
  import InputWidget from "@/core/components/input-widget/InputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('liveBids');

  export default {
    name: "UnsoldLotModal",
    components: {
      InputWidget,
      BidderSelectInputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new UnsoldLotModel(),
      }
    },
    computed: {
      ...mapState({
        saleInfo: state => state.sale.saleInfo,
        activeLot: state => state.sale.activeLot,
        modal: state => state.unsoldLotModal,
      })
    },
    methods: {
      ...mapActions(['hideUnsoldLotModal', 'markUnsold']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new UnsoldLotModel()
        this.hideUnsoldLotModal();
      },
      async onSubmit() {
        this.model.resetErrors()
        this.showConfirmation = false;
        let params = {uuid: this.activeLot.uuid, status: 'unsold'}

        if (this.model.paddle_number && this.model.highest_bid_amount && this.model.highest_bid_amount > 0) {
          params.highest_bid_amount = this.model.highest_bid_amount
          params.paddle_number = this.model.paddle_number
        }

        let response = await this.markUnsold(params);

        if (response.success) {
          this.$toast('success', this.$i18n.t('Lot {lot} was marked as unsold', {lot: this.activeLot.lot_no}));
          this.$emit('success')
          this.hideUnsoldLotModal()
        } else {
          this.showConfirmation = true;
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0], this.$i18n.t("Error while processing request"));
          } else {
            this.model.setMultipleErrors(response.body)
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
